<!--
	@name app-firm-dialog-add-trading-style
	@description Show a dialog to add a trading style
	@date 2020/08/26
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<common-dialog ref="dialog" :component="$options.name" :max-width="500">
		<template #header>
			Add New Trading Style
		</template>

		<template #body>
			<dynamic-form
				ref="dynamicForm"
				:submit-button-text="'Create Trading Style'"
				:form-schema="form"
				:form-data="formData"
				:submit-button-loading="submitting"
				@dynamic-form-submit="addTradingStyle"
			/>
		</template>
	</common-dialog>
</template>

<script>
	import { mapActions, mapState } from 'vuex';
	import { ElementTools } from '@/utils';
	import CommonDialog from '@/component/common/dialog';
	import DynamicForm from '@/component/common/base/dynamic-form';

	export default {
		name: 'app-firm-dialog-add-trading-style',

		components: { CommonDialog, DynamicForm },

		props: {
			form: { type: Array, required: true, default: () => [] }
		},

		data() {
			return {
				submitting: false,
				formData: {}
			};
		},

		computed: {
			...mapState('Account', ['organisation'])
		},

		methods: {
			...mapActions('AccountOrganisationTradingStyle', ['addOrganisationTradingStyle']),

			/**
			 * @name addTradingStyle
			 * @description Sends request to add a trading style
			 */
			async addTradingStyle() {
				this.submitting = true;

				this.addOrganisationTradingStyle({ name: this.formData.name, data: { fca: this.formData.fca } })
					.then(() => {
						ElementTools.fireNotification(this.$el, 'success', 'Trading style has been successfully added');
						this.$refs.dialog.close();
					})
					.catch((e) => {
						let message = 'Failed to add trading style';
						if (e.data.message === 'Cannot duplicate a unique value, value already exists') message = 'Trading style has already been added for the firm';
						ElementTools.fireNotification(this.$el, 'error', message);
					})
					.finally(() => (this.submitting = false));
			},

			/**
			 * @name open
			 * @description Open dialog and set properties
			 */
			open() {
				this.formData = {
					editFCA: this.organisation.data?.tradingStyles?.editFCA
				};
				this.$refs.dialog.open();
			}
		}
	};
</script>
